// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.

export const DEFAULT_ENCODING = 'utf8';
